import { Component, input, signal } from '@angular/core';
import { BeforeAfter, SetupWizardPreviewStatus, SetupWizardLocation, SetupWizardUser } from '@mira-avant/mtlibs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import {
	BEFORE_AFTER_STATUS_CHANGED_COLOR,
	BEFORE_AFTER_STATUS_NEW_COLOR,
	BEFORE_AFTER_STATUS_UNCHANGED_COLOR,
	BEFORE_AFTER_STATUS_UPSERT_COLOR,
} from '../setup-wizard-before-after-status/setup-wizard-before-after-status';
import { Subscription } from 'rxjs/internal/Subscription';
import { SetupWizard } from '../../../../../../services/setup-wizard';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, distinctUntilChanged } from 'rxjs';

@Component({
	selector: 'app-setup-wizard-before-after-status-with-assignment',
	imports: [NzTagModule, NzTooltipModule],
	standalone: true,
	templateUrl: './setup-wizard-before-after-status-with-assignment.html',
	styleUrl: './setup-wizard-before-after-status-with-assignment.scss',
})
export class SetupWizardBeforeAfterStatusWithAssignment<T> {
	upsertMode = input<boolean>(false);
	data = input.required<BeforeAfter<T>>();
	user = input<SetupWizardUser | null>(null);
	location = input<SetupWizardLocation | null>(null);
	hasAssignmentChanged = signal<boolean>(false);
	SetupWizardPreviewStatus = SetupWizardPreviewStatus;
	public BEFORE_AFTER_STATUS_UPSERT_COLOR = BEFORE_AFTER_STATUS_UPSERT_COLOR;
	public BEFORE_AFTER_STATUS_NEW_COLOR = BEFORE_AFTER_STATUS_NEW_COLOR;
	public BEFORE_AFTER_STATUS_CHANGED_COLOR = BEFORE_AFTER_STATUS_CHANGED_COLOR;
	public BEFORE_AFTER_STATUS_UNCHANGED_COLOR = BEFORE_AFTER_STATUS_UNCHANGED_COLOR;
	private sub?: Subscription;

	constructor(private setupWizard: SetupWizard) {
		const location$ = toObservable(this.location).pipe(distinctUntilChanged());
		const user$ = toObservable(this.user).pipe(distinctUntilChanged());

		this.sub = combineLatest([this.setupWizard.preview$, location$, user$]).subscribe(
			([preview, location, user]) => {
				if (!location && !user) {
					throw new Error('Either location or user must be provided');
				}

				if (location) {
					const hasChanged = this.setupWizard.hasLocationAssignmentChanged(location);
					this.hasAssignmentChanged.set(hasChanged);
				} else if (user) {
					const hasChanged = this.setupWizard.hasUserAssignmentChanged(user);
					this.hasAssignmentChanged.set(hasChanged);
				} else {
					this.hasAssignmentChanged.set(false);
				}
			}
		);
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
	}
}
